import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import homeRoutes from './home/home';
import paymentRequestRoutes from './paymentRequest/paymentRequest';
import paymentRoutes from './payment/payment';
import passwordRecoveryRoutes from './passwordRecovery/passwordRecovery';
import invoiceDetailsRoutes from './invoiceDetails/invoiceDetails';
import store from '../store/index';
import multiplesMiddleware from './middlewarePipeline';
import oauthRedirect from './oauthRedirect/oauthRedirect';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/home/pdf-preview/:pdf',
    name: 'pdf-preview',
  },
  ...homeRoutes,
  ...paymentRequestRoutes,
  ...paymentRoutes,
  ...passwordRecoveryRoutes,
  ...invoiceDetailsRoutes,
  ...oauthRedirect,
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  // eslint-disable-next-line
  const middleware = to.meta.middleware;

  const context = {
    to,
    from,
    router,
    store,
    next,
  };

  return to.meta.middleware[0]({
    ...context,
    next: multiplesMiddleware(context, middleware, 1),
  });
});

export default router;
